import { render, staticRenderFns } from "./TilesLayerControl.vue?vue&type=template&id=71e6574a"
import script from "./TilesLayerControl.vue?vue&type=script&lang=js"
export * from "./TilesLayerControl.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports